export const NativeErrorCode = {
    auth: {
        USER_NOT_FOUND: 'USER_NOT_FOUND',
        USER_NAME_NOT_FOUND: 'USER_NAME_NOT_FOUND',
        UNABLE_TO_SAVE_DATA: 'UNABLE_TO_SAVE_DATA',
        UNABLE_TO_RETRIEVE_DATA: 'UNABLE_TO_RETRIEVE_DATA',
        NO_STUDY_ACCESS: 'NO_STUDY_ACCESS',
    },
};
